import type { Row } from './types';

const num = (v: unknown) => {
  const n = typeof v === 'number' ? v : Number(String(v ?? '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};
const key = (r: Row, f: string) => Object.keys(r).find((k) => k.toUpperCase() === f) ?? f;
const pick = (r: Row, f: string) => r[key(r, f)];

/**
 * Otomatik Evrak No (server/src/documents/firin-calc.ts otomatikEvrakNo ile aynı kural).
 *  İRSALİYE (Form80_3): TOPLAM_ADET<=0 ve TIPI<>'Cari' satırlar silinir; başlangıçtan itibaren her satıra sıradaki numara.
 *  FATURA (Form80_4): silme yok; cari değiştikçe numara bir artar.
 * Dönen `silinen` indeksleri giriş dizisine göredir.
 */
export function otomatikEvrakNo(rows: Row[], ilkNo: number, o: { tur: 'İRSALİYE' | 'FATURA'; baslangicIndex: number; hepsi: boolean }) {
  const idx = rows.map((_, i) => i);
  let keep = idx;
  const silinen: number[] = [];
  let start = o.hepsi ? 0 : Math.max(0, o.baslangicIndex);
  const yeni: Record<number, string> = {};
  if (o.tur === 'İRSALİYE') {
    const startOrig = start;
    keep = [];
    for (const i of idx) {
      const r = rows[i];
      if (num(pick(r, 'TOPLAM_ADET')) <= 0 && String(pick(r, 'TIPI') ?? '') !== 'Cari') silinen.push(i);
      else keep.push(i);
    }
    start = o.hepsi ? 0 : Math.max(0, keep.indexOf(startOrig));
    let n = ilkNo;
    for (let x = start; x < keep.length; x++) { yeni[keep[x]] = String(n); n++; }
  } else {
    let n = ilkNo;
    let cari = num(pick(rows[start] ?? {}, 'CARI_ID'));
    for (let x = start; x < rows.length; x++) {
      const c = num(pick(rows[x], 'CARI_ID'));
      if (c !== cari) { n++; cari = c; }
      yeni[x] = String(n);
    }
  }
  return { yeni, silinen };
}
